import React, {
    useState,
    useImperativeHandle,
} from "react";
import {
    Box,
    Grid,
    Typography,
    TextField,
    MenuItem,
    Paper,
    IconButton,
    FormControl,
    InputLabel,
    Select,
    Autocomplete,
    FormControlLabel,
    CheckboxProps,
    Checkbox,
} from "@mui/material";
import { blue } from "@mui/material/colors";
import Slide from "@mui/material/Slide";
import ArrowCircleRightTwoToneIcon from "@mui/icons-material/ArrowCircleRightTwoTone";
import { makeStyles } from "@material-ui/core/styles";
import { withStyles, Theme } from "@material-ui/core/styles";
import CircularProgress from "@mui/material/CircularProgress";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { StyledTextInput } from "../StyledComponents/StyledInputs";
import { makeGETRequest, makePUTRequestOnUserService } from "../../Api/api";
import { sxRoot, sxText, sxTypo, sxBox } from "../../Helpers/helpers";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

const useStyles = makeStyles((theme) => ({
    form: {
        display: "flex",
        flexDirection: "column",
        margin: "auto",
        width: "fit-content",
    },
    formControl: {
        marginTop: theme.spacing(2),
        minWidth: 120,
    },
    formControlLabel: {
        marginTop: theme.spacing(1),
    },
}));

const convertToDate = (date: any) => {
    if (date) {
        var dd = String(date.getDate()).padStart(2, "0");
        var mm = String(date.getMonth() + 1).padStart(2, "0");
        var yyyy = date.getFullYear();
        return dd + "/" + mm + "/" + yyyy;
    } else return "";
};

const Transition = React.forwardRef(function Transition(props: any, ref: any) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const BlueCheckbox = withStyles((theme: Theme) => ({
    root: {
        color: blue[800],
        "&$checked": {
            color: blue[800],
        },
    },
    checked: {},
}))((props: CheckboxProps) => <Checkbox color="default" {...props} />);

interface PartnerClientEditDetailsProps {
    data: any;
    user_type: string;
}

interface LeadOption {
    id: string;
    name: string;
    mobile: string;
    email: string;
}

const PartnerClientEditDetails = React.forwardRef(function PartnerClientEditDetails(
    props: PartnerClientEditDetailsProps,
    ref: any
) {
    const { data, user_type } = props;
    const toastr = require("toastr");
    const currentUser = data;
    const classes = useStyles();
    const loginUser = JSON.parse(localStorage.getItem("loginUser") || "{}");
    const adminName = loginUser?.name || "";

    const accountTypeOptions = [
        "Individual Resident",
        "Individual Non-Resident",
        "Hindu Undivided Family",
        "Sole Proprietor",
        "Limited Liability Partnership",
        "Partnership",
        "Private Limited",
        "Trust",
        "Public Limited",
    ];

    const [currentState, setCurrentState] = useState({
        ...currentUser,
        firstName: currentUser?.first_name || "",
        lastName: currentUser?.last_name || "",
        mobileNumber: currentUser?.mobile_number || "",
        emailId: currentUser?.email_id || "",
        dateOfBirth: currentUser?.date_of_birth || "",
        birthCountry: currentUser?.birth_country || "",
        isPanCardSubmitted: currentUser?.is_pan_card_submitted || false,
        isAddressProofSubmitted: currentUser?.is_address_proof_submitted || false,
        hasPoliticalExposure: currentUser?.hasPoliticalExposure || false,
        annualIncome: currentUser?.annualIncome || "",
        maritalStatus: currentUser?.maritalStatus || "",
        maidenName: currentUser?.maidenName || "",
        motherName: currentUser?.motherName || "",
        fathersName: currentUser?.fathersName || "",
        occupation: currentUser?.occupation || "",
        gender: currentUser?.gender || "",
        nationality: currentUser?.nationality || "",
        address: currentUser?.address || "",
        city: currentUser?.city || "",
        state: currentUser?.state || "",
        pincode: currentUser?.pincode || "",
        gstin: currentUser?.gstin || "",
        investedBefore: currentUser?.investedBefore || false,
        canSendWhatsappUpdates: currentUser?.canSendWhatsappUpdates || false,
        isChequeSubmitted: currentUser?.isChequeSubmitted || false,
        isPennyDropComplete: currentUser?.isPennyDropComplete || false,
        isDematProofSubmitted: currentUser?.isDematProofSubmitted || false,
        isESignComplete: currentUser?.isESignComplete || false,
        areKYCDetailsVerified: currentUser?.areKYCDetailsVerified || false,
    });
    const [leadOpen, setLeadOpen] = useState(false);
    const [lead, setLead] = useState<LeadOption | null>(null);
    const [leadOptions, setLeadOptions] = useState<LeadOption[]>([]);
    const [loading, setLoading] = useState(false);
    const [statusOpen, setStatusOpen] = useState(false);
    const [status, setStatus] = useState(currentUser?.leadsstatus || "Raw");
    const [followUpDate, setFollowUpDate] = useState(
        currentUser?.leadstofollow_up || ""
    );
    const [remark, setRemark] = useState(currentUser?.leadsremarks || "");
    const [ucc, setUCC] = useState(currentUser?.ucc_external_id || "");

    function handleUCCUpdate() {
        makePUTRequestOnUserService("/order_management_v2/user/ucc_update/", {
            ucc_external_id: ucc,
            user_id: currentUser?.uuid,
            user_type: user_type,
        })
            .then((response) => {
                if (response && response.status === 200) {
                    toastr.success("UCC Updated successfully!");
                }
            })
            .catch((error) => toastr.error(error));
    }

    React.useEffect(() => {
        let active = true;
        setLoading(true);

        makeGETRequest("/users/all/list/")
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (active) {
                        if (data.length === 0) {
                            toastr.warning("No Admin users found!");
                        } else {
                            const optionsArray: LeadOption[] = data.map((item: any) => ({
                                id: item.uuid,
                                name: `${item.firstName} ${item.lastName}`,
                                mobile: item.mobileNumber,
                                email: item.emailId,
                            }));
                            setLeadOptions(optionsArray);
                            if (currentUser?.leads_uuid) {
                                const currentLeadOwner = optionsArray.find(
                                    (option: LeadOption) => option.id === currentUser.leads_uuid
                                );
                                if (currentLeadOwner) {
                                    setLead(currentLeadOwner);
                                }
                            }
                        }
                    }
                }
            })
            .catch((error) => {
                console.error("Error fetching admin users:", error);
                toastr.error("Failed to fetch admin users");
            })
            .finally(() => {
                if (active) {
                    setLoading(false);
                }
            });

        return () => {
            active = false;
        };
    }, []);

    const handleLeadClose = () => {
        setLeadOpen(false);
    };

    function handleChange(event: any) {
        setCurrentState((previousValues: any) => ({
            ...previousValues,
            [event.target.name]: event.target.value,
        }));
    }

    const handleCheckBox = (event: any) => {
        setCurrentState((previousValues: any) => ({
            ...previousValues,
            [event.target.name]: event.target.checked,
        }));
    };

    const handleSave = async () => {
        try {
            const payload = {
                firstName: currentState.firstName,
                lastName: currentState.lastName,
                mobileNumber: currentState.mobileNumber,
                emailId: currentState.emailId,
                dateOfBirth: currentState.dateOfBirth,
                birthCountry: currentState.birthCountry,
                isPanCardSubmitted: currentState.isPanCardSubmitted,
                isAddressProofSubmitted: currentState.isAddressProofSubmitted,
                hasPoliticalExposure: currentState.hasPoliticalExposure,
                annualIncome: currentState.annualIncome,
                maritalStatus: currentState.maritalStatus,
                maidenName: currentState.maidenName,
                motherName: currentState.motherName,
                fathersName: currentState.fathersName,
                occupation: currentState.occupation,
                gender: currentState.gender,
                nationality: currentState.nationality,
                address: currentState.address,
                city: currentState.city,
                state: currentState.state,
                pincode: currentState.pincode,
                gstin: currentState.gstin,
                investedBefore: currentState.investedBefore,
                canSendWhatsappUpdates: currentState.canSendWhatsappUpdates,
                isChequeSubmitted: currentState.isChequeSubmitted,
                isPennyDropComplete: currentState.isPennyDropComplete,
                isDematProofSubmitted: currentState.isDematProofSubmitted,
                isESignComplete: currentState.isESignComplete,
                areKYCDetailsVerified: currentState.areKYCDetailsVerified,
                accountType: currentState.accountType,
                user_type: user_type,
                uuid: currentState.uuid,
                adminName: adminName,
                leadsstatus: status,
                leadsremarks: remark,
                leadstofollow_up: followUpDate,
                leads: lead ? {
                    lead_uuid: lead.id,
                    leadowner: lead.name,
                    leadownerphone: lead.mobile,
                    leadowneremail: lead.email,
                } : {},
            };

            const response = await makePUTRequestOnUserService(
                "/partneruser/user/update/admin_panel/",
                payload
            );

            if (response?.status === 200) {
                toastr.success(
                    "User details updated successfully!"
                );
                return true;
            }

            toastr.error("Failed to update user");
            return false;
        } catch (error) {
            console.log(error);
            toastr.error("Something went wrong");
            return false;
        }
    };

    useImperativeHandle(ref, () => ({
        saveData: handleSave,
    }));

    function renderAccountType() {
        return (
            <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ width: "80%" }}
            >
                <InputLabel id="demo-simple-select-outlined-label">
                    Account Type
                </InputLabel>
                <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    name="accountType"
                    value={currentState.accountType || ""}
                    onChange={handleChange}
                    label="Account Type"
                >
                    {accountTypeOptions &&
                        accountTypeOptions.length > 0 &&
                        accountTypeOptions.map((accountTypeOption, index) => {
                            return (
                                <MenuItem value={accountTypeOption} key={index}>
                                    {accountTypeOption}
                                </MenuItem>
                            );
                        })}
                </Select>
            </FormControl>
        );
    }

    return (
        <>
            <Box sx={{ width: ["100%", 400], mx: "auto", mt: 5 }}>
                <Autocomplete
                    id={"user-select"}
                    value={lead}
                    onChange={(_, newValue) => {
                        setLead(newValue);
                    }}
                    open={leadOpen}
                    onOpen={() => {
                        setLeadOpen(true);
                    }}
                    onClose={handleLeadClose}
                    isOptionEqualToValue={(option: LeadOption, value: LeadOption) =>
                        option?.id === value?.id
                    }
                    getOptionLabel={(option: LeadOption) => option?.name || ""}
                    options={leadOptions}
                    loading={loading}
                    size="medium"
                    sx={sxRoot}
                    popupIcon={<ExpandMoreIcon />}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Select Lead Owner"
                            sx={(theme) => sxText(theme)}
                            id={"user-select"}
                            fullWidth
                            margin="dense"
                            variant="standard"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {loading ? (
                                            <CircularProgress color="error" size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            }}
                        />
                    )}
                    renderOption={(props, option: LeadOption, { selected }) => (
                        <Typography {...props} sx={sxTypo(selected)} variant="h6">
                            {option.name}
                        </Typography>
                    )}
                    PaperComponent={({ children }) => {
                        return <Paper sx={{ maxHeight: 200, overflow: 'auto' }}>{children}</Paper>;
                    }}
                />
                <Autocomplete
                    id={"user-status"}
                    value={status}
                    onChange={(_, newValue) => {
                        setStatus(newValue || "Raw");
                        setCurrentState((previousValues: any) => ({
                            ...previousValues,
                            leadsstatus: newValue ?? "",
                            ...(newValue !== "Bad Timing" && { leadstofollow_up: "" }),
                            ...(newValue !== "Others" && { leadsremarks: "" }),
                        }));
                    }}
                    open={statusOpen}
                    onOpen={() => {
                        setStatusOpen(true);
                    }}
                    onClose={() => {
                        setStatusOpen(false);
                    }}
                    isOptionEqualToValue={(option, value) => option === value}
                    getOptionLabel={(option) => option}
                    options={[
                        "Raw",
                        "Assigned",
                        "Bad Timing",
                        "In Talks",
                        "Qualified",
                        "Not Interested",
                        "Others",
                        "Existing Investor",
                    ]}
                    size="medium"
                    sx={sxRoot}
                    popupIcon={<ExpandMoreIcon />}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Select Lead Status"
                            sx={(theme) => sxText(theme)}
                            id={"user-status"}
                            fullWidth
                            margin="dense"
                            variant="standard"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: <>{params.InputProps.endAdornment}</>,
                            }}
                        />
                    )}
                    renderOption={(props, option, { selected }) => (
                        <Typography {...props} sx={sxTypo(selected)} variant="h6">
                            {option}
                        </Typography>
                    )}
                    PaperComponent={({ children }) => {
                        return <Paper sx={{ maxHeight: 200, overflow: 'auto' }}>{children}</Paper>;
                    }}
                />
                {status === "Bad Timing" && (
                    <FormControl
                        fullWidth
                        variant="standard"
                        style={{ marginTop: 10 }}
                    >
                        <InputLabel shrink htmlFor="followUpDate">
                            Follow Up Date
                        </InputLabel>
                        <StyledTextInput
                            id="followUpDate"
                            type="date"
                            value={followUpDate}
                            onChange={(event: any) => {
                                setFollowUpDate(event.target.value);
                                setCurrentState((previousValues: any) => ({
                                    ...previousValues,
                                    leadstofollow_up: event.target.value ?? "",
                                }));
                            }}
                        />
                    </FormControl>
                )}
                {status === "Others" && (
                    <FormControl
                        fullWidth
                        variant="standard"
                        style={{ marginTop: 10 }}
                    >
                        <InputLabel shrink htmlFor="remark">
                            Remarks
                        </InputLabel>
                        <StyledTextInput
                            id="remark"
                            value={remark}
                            onChange={(event: any) => {
                                setRemark(event.target.value);
                                setCurrentState((previousValues: any) => ({
                                    ...previousValues,
                                    leadsremarks: event.target.value ?? "",
                                }));
                            }}
                        />
                    </FormControl>
                )}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "center",
                    }}
                >
                    <FormControl variant="standard" style={{ marginTop: 10 }}>
                        <InputLabel shrink htmlFor="smestId">
                            Smest ID
                        </InputLabel>
                        <StyledTextInput
                            id="smestId"
                            disabled
                            value={currentState?.smest_id || ""}
                        />
                    </FormControl>
                    <FormControl
                        variant="standard"
                        style={{ marginTop: 10, marginLeft: 10 }}
                    >
                        <InputLabel shrink htmlFor="ucc">
                            Update UCC
                        </InputLabel>
                        <StyledTextInput
                            id="ucc"
                            value={ucc}
                            onChange={(event: any) => {
                                setUCC(event.target.value);
                            }}
                        />
                    </FormControl>
                    <IconButton
                        sx={{ mb: 0.5, ml: 1, color: "#7659EE", p: 0 }}
                        onClick={handleUCCUpdate}
                    >
                        <ArrowCircleRightTwoToneIcon fontSize="large" />
                    </IconButton>
                </Box>
            </Box>

            <Grid className="editUserDetailsDialogSection">
                <Grid container spacing={3}>
                    <Grid item lg={4} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">First Name</Grid>
                            <TextField
                                id="firstName"
                                name="firstName"
                                variant="standard"
                                value={currentState.firstName || ""}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>

                    <Grid item lg={4} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">Maiden Name</Grid>
                            <TextField
                                id="maidenName"
                                name="maidenName"
                                variant="standard"
                                value={currentState.maidenName || ""}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>

                    <Grid item lg={4} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">Last Name</Grid>
                            <Typography variant="h6" noWrap>
                                <TextField
                                    id="lastName"
                                    name="lastName"
                                    variant="standard"
                                    value={currentState.lastName || ""}
                                    onChange={handleChange}
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">Mobile Number</Grid>
                            <TextField
                                id="mobileNumber"
                                name="mobileNumber"
                                variant="standard"
                                value={currentState.mobileNumber || ""}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">Email ID</Grid>
                            <Typography variant="h6" noWrap>
                                <TextField
                                    id="emailId"
                                    name="emailId"
                                    variant="standard"
                                    value={currentState.emailId || ""}
                                    onChange={handleChange}
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">Father's Name</Grid>
                            <TextField
                                id="fathersName"
                                name="fathersName"
                                variant="standard"
                                value={currentState.fathersName || ""}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">Mother's Name</Grid>
                            <Typography variant="h6" noWrap>
                                <TextField
                                    id="motherName"
                                    name="motherName"
                                    variant="standard"
                                    value={currentState.motherName || ""}
                                    onChange={handleChange}
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">Gender</Grid>
                            <TextField
                                id="gender"
                                name="gender"
                                variant="standard"
                                value={currentState.gender || ""}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">Marital Status</Grid>
                            <Typography variant="h6" noWrap>
                                <TextField
                                    id="maritalStatus"
                                    name="maritalStatus"
                                    variant="standard"
                                    value={currentState.maritalStatus || ""}
                                    onChange={handleChange}
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item lg={12} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">Address</Grid>
                            <Typography variant="h6" noWrap>
                                <TextField
                                    id="address"
                                    name="address"
                                    variant="standard"
                                    style={{ width: "500px" }}
                                    fullWidth
                                    value={currentState.address || ""}
                                    onChange={handleChange}
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            {renderAccountType()}
                        </Grid>
                    </Grid>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">City</Grid>
                            <Typography variant="h6" noWrap>
                                <TextField
                                    id="city"
                                    name="city"
                                    variant="standard"
                                    value={currentState.city || ""}
                                    onChange={handleChange}
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">Pincode</Grid>
                            <TextField
                                id="pincode"
                                name="pincode"
                                variant="standard"
                                value={currentState.pincode || ""}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">State</Grid>
                            <Typography variant="h6" noWrap>
                                <TextField
                                    id="state"
                                    name="state"
                                    variant="standard"
                                    value={currentState.state || ""}
                                    onChange={handleChange}
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">Annual Income</Grid>
                            <TextField
                                id="annualIncome"
                                name="annualIncome"
                                variant="standard"
                                value={currentState.annualIncome || ""}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>

                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">Birth Country</Grid>
                            <Typography variant="h6" noWrap>
                                <TextField
                                    id="birthCountry"
                                    name="birthCountry"
                                    variant="standard"
                                    value={currentState.birthCountry || ""}
                                    onChange={handleChange}
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">Occupation</Grid>
                            <TextField
                                id="occupation"
                                name="occupation"
                                variant="standard"
                                value={currentState.occupation || ""}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">GSTIN</Grid>
                            <Typography variant="h6" noWrap>
                                <TextField
                                    id="gstin"
                                    name="gstin"
                                    variant="standard"
                                    value={currentState.gstin || ""}
                                    onChange={handleChange}
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Grid className="profileInfoDateTitle">Nationality</Grid>
                            <TextField
                                id="nationality"
                                name="nationality"
                                variant="standard"
                                value={currentState.nationality || ""}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Typography variant="h6" noWrap>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid item xs={8}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="date-picker-dialog"
                                            label="Date Of Birth"
                                            format="dd/MM/yyyy"
                                            value={currentState.dateOfBirth ? new Date(currentState.dateOfBirth) : null}
                                            onChange={(date) => {
                                                setCurrentState((prevState: any) => ({
                                                    ...prevState,
                                                    dateOfBirth: convertToDate(date),
                                                }));
                                            }}
                                            KeyboardButtonProps={{
                                                "aria-label": "change date",
                                            }}
                                        />
                                    </Grid>
                                </MuiPickersUtilsProvider>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <FormControlLabel
                                control={
                                    <BlueCheckbox
                                        checked={currentState.hasPoliticalExposure || false}
                                        onChange={handleCheckBox}
                                        name="hasPoliticalExposure"
                                    />
                                }
                                label="Has Political Exposure ?"
                            />
                        </Grid>
                    </Grid>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Typography variant="h6" noWrap>
                                <FormControlLabel
                                    control={
                                        <BlueCheckbox
                                            checked={currentState.investedBefore || false}
                                            onChange={handleCheckBox}
                                            name="investedBefore"
                                        />
                                    }
                                    label="Invested Before ?"
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <FormControlLabel
                                control={
                                    <BlueCheckbox
                                        checked={currentState.isPanCardSubmitted || false}
                                        onChange={handleCheckBox}
                                        name="isPanCardSubmitted"
                                    />
                                }
                                label="Is Pan Card Submitted"
                            />
                        </Grid>
                    </Grid>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Typography variant="h6" noWrap>
                                <FormControlLabel
                                    control={
                                        <BlueCheckbox
                                            checked={currentState.isAddressProofSubmitted || false}
                                            onChange={handleCheckBox}
                                            name="isAddressProofSubmitted"
                                        />
                                    }
                                    label="Is Address Proof Submitted"
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <FormControlLabel
                                control={
                                    <BlueCheckbox
                                        checked={currentState.isChequeSubmitted || false}
                                        onChange={handleCheckBox}
                                        name="isChequeSubmitted"
                                    />
                                }
                                label="Is Cheque Submitted"
                            />
                        </Grid>
                    </Grid>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Typography variant="h6" noWrap>
                                <FormControlLabel
                                    control={
                                        <BlueCheckbox
                                            checked={currentState.isPennyDropComplete || false}
                                            onChange={handleCheckBox}
                                            name="isPennyDropComplete"
                                        />
                                    }
                                    label="Is Penny Drop Complete"
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <FormControlLabel
                                control={
                                    <BlueCheckbox
                                        checked={currentState.isDematProofSubmitted || false}
                                        onChange={handleCheckBox}
                                        name="isDematProofSubmitted"
                                    />
                                }
                                label="Is Demat Proof Submitted"
                            />
                        </Grid>
                    </Grid>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <Typography variant="h6" noWrap>
                                <FormControlLabel
                                    control={
                                        <BlueCheckbox
                                            checked={currentState.isESignComplete || false}
                                            onChange={handleCheckBox}
                                            name="isESignComplete"
                                        />
                                    }
                                    label="Is E-Sign Complete"
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <FormControlLabel
                                control={
                                    <BlueCheckbox
                                        checked={currentState.areKYCDetailsVerified || false}
                                        onChange={handleCheckBox}
                                        name="areKYCDetailsVerified"
                                    />
                                }
                                label="Are KYC Details Verified"
                            />
                        </Grid>
                    </Grid>
                    <Grid item lg={6} sm={12}>
                        <Grid className="editUserDetailsDate">
                            <FormControlLabel
                                control={
                                    <BlueCheckbox
                                        checked={currentState.canSendWhatsappUpdates || false}
                                        onChange={handleCheckBox}
                                        name="canSendWhatsappUpdates"
                                    />
                                }
                                label="Enable Whatsapp Updates ?"
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}
);

export default React.memo(PartnerClientEditDetails);